import styled from '@emotion/styled';
import { mq } from '../../../../styles/mixins';
import { css } from '@emotion/react';
import Link from 'next/link';
import { ParagraphM, ParagraphS } from '../../../core/Typography/Typography';
import { THEME } from '../../../../common/consts/theme';
import { rgba } from 'emotion-rgba';

export const JobItemWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
  max-width: 40rem;

  ${mq.medium(css`
    flex-wrap: nowrap;
    margin-bottom: 1.25rem;
  `)};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const Underline = styled.span`
  border-bottom: 0.125rem solid;
  border-image: linear-gradient(90deg, #394dbc 0%, #844b8d 100.75%);
  border-image-slice: 1;
  border-top: 0;
  border-left: 0;
  border-right: 0;
`;

export const InnerUnderline = styled.span`
  border-bottom: 0.125rem solid ${({ theme }) => theme.colors.primary};
  transition: border-bottom-color 200ms ease-in-out;
`;

export const JobPosition = styled(Link)`
  margin: 0;
  ${ParagraphM};
  font-weight: 400;
  font-family: ${({ theme }) => theme.font.questrial};
  background: linear-gradient(
    22.45deg,
    ${THEME.colors.primary} 3.28%,
    ${THEME.colors.accent} 102.02%
  );
  background-clip: text;
  color: ${rgba(THEME.colors.primary, 1)};
  transition: color 200ms ease-in-out;
  text-decoration: none;

  &:hover {
    color: ${rgba(THEME.colors.primary, 0)};

    &:after {
      opacity: 1;
    }

    ${InnerUnderline} {
      border-bottom-color: transparent;
    }
  }

  ${mq.medium(css`
    margin-right: 1rem;
    font-size: 1.5rem;
    flex: 0 0 auto;
  `)};
`;

export const JobSalary = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.core_black};
  ${ParagraphS};
  flex: 0 0 100%;

  ${mq.medium(css`
    font-weight: 400;
    font-size: 1.5rem;
    flex: 0 0 auto;
  `)};
`;
